var ContactForm = function () {

	this.init = function () {
		$('[data-component="contact-form"]').on('submit', function(event) {
			event.preventDefault();
		})

	}

	return this.init();
}

$('#canais-de-atendimento input, #canais-de-atendimento select, #canais-de-atendimento textarea').click(function(){
	$(this).removeClass('invalid-field');
});
